export default __webpack_public_path__ + "static/media/s-3.8ef009cd.jpg";